export default {"src":"/_next/static/media/Endocarditis2x.b02e3573.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};